<template>
  <div class="page-column">
    <Header :type="true"/>
    <Index />
    <Footer />
  </div>
</template>

<script>
import Header from '../layout/Header.vue'
import Index from '../../components/center/Index.vue'
import Footer from '../layout/Footer.vue'
export default {
  components: {
    Header,
    Index,
    Footer
  },
  created () {
    document.title = '个人中心'
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/center/Index.vue